// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/old-app","css/pages/admin-dashboard"], () => (__webpack_require__("./resources/js/app.js")))
__webpack_require__.O(undefined, ["css/old-app","css/pages/admin-dashboard"], () => (__webpack_require__("./resources/scss/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/old-app","css/pages/admin-dashboard"], () => (__webpack_require__("./resources/scss/pages/admin-dashboard.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
